import dynamic from "next/dynamic";

export const HexagonTabs = dynamic(() => import("./component"));
